// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"SectionLabel_mainContainer__F5zCq","mainContainerSmall":"SectionLabel_mainContainerSmall__Wo5h6"};